<template>
  <common-dialog ref="dialog" title="查看 对账单" width="1000px" in-dialog>
    <list
      row-key="BillDtsId"
      ref="list"
      unit="人员对账单"
      :page="page"
      show-checkbox
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right">
          <el-button @click="onExport" type="primary" v-if="$permission.canWrite()">导出</el-button>
        </slot>
      </template>
      <template slot="query">
        <el-form-item label="人员名称">
          <el-input v-model="params.MemberName" placeholder="请输入人员名称" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="人员名称" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.MemberType==0">{{row.StudentName}}</span>
            <span v-else>{{row.TeacherName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="人员类别" width="90">
          <template slot-scope="{row}">
            <span v-if="row.MemberType==0">学生</span>
            <span v-if="row.MemberType==1">教职人员</span>
          </template>
        </el-table-column>
        <el-table-column prop="BeginTotalBalance" label="期初总余额" width="90" />
        <el-table-column prop="RechargeAmount" label="账号充值总金额" width="110" />
        <el-table-column prop="WxTradeAmount" label="微信到账总金额" width="110" />
        <el-table-column prop="GiveAmount" label="后台充值总金额" width="110" />
        <el-table-column prop="ConsumeAmount" label="账号消费总金额" width="110" />
        <el-table-column prop="DeviceAmount" label="机器消费总金额" width="110" />
        <el-table-column prop="RefundAmount" label="退款总金额" width="110" />
        <el-table-column prop="EndTotalBalance" label="账号剩余总余额" width="110" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <template slot="footer">
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import listDialogMixin from "@/mixins/listDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/components/common/list";
export default {
  mixins: [listDialogMixin],
  components: { commonDialog, list },
  data() {
    return {
      api: require("@/api/cp/billdts").default,
      params: {
        BillId: null,
        MemberName: "",
        // MemberType: null,
      },
      data: {
        StartDate: null,
        MemberType: null,
      },
    };
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.export(params).then(() => {
        loading.close();
      });
    },
  },
};
</script>